import React from 'react';

import Icon from '~/components/Icon';
import Modal from '~/components/Modal';
import { wrapDialog } from '~/helpers/dialog-helper';
import { PICTURE_REJECT_REASONS } from '~/values/enums';

import styles from './ModalValidatePhoto.module.scss';

const modalValidatePhoto = ({ rejectionReason, ...others }) => {
    return (
        <Modal
            {...others}
            footer={null}
        >
            <div className={styles.container}>
                <Icon name="OutlineCancel" size={32} className={styles.icon} />
                <div>
                    <div className={styles.title}>
                        Foto inválida. Por favor tire uma nova foto.
                        <div className={styles.subtitle}>
                            Motivo: {PICTURE_REJECT_REASONS.getLabelByKey(rejectionReason)}
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default wrapDialog(modalValidatePhoto);
